import React from "react";
import styled from "styled-components";

import * as Icons from "./components";
import { IconProps } from "./types";

type StyledComponentsProps = Partial<IconProps>;

const IconContainer = styled.div<StyledComponentsProps>`
  display: inline-block;
  position: relative;
  width: ${props => `${props.size}px`};
  height: ${props => `${props.size}px`};
  & svg {
    width: 100%;
    height: auto;
    color: ${props => props.color};
  }
`;

const Icon: React.FC<IconProps> = ({
  name,
  size = 24,
  color = "#000",
  className,
  style,
}) => {
  const RenderedIcon: React.FC = Icons[name];

  if (!name) {
    return null;
  }

  return (
    <IconContainer
      size={size}
      color={color}
      data-testid="icon"
      style={style}
      className={className}
    >
      <RenderedIcon />
    </IconContainer>
  );
};

export * from "./components";
export default Icon;
